import { RootState } from "../app/store";

export const selectTriv5State = (state: RootState) => state.triv5Reducer;
